import React from "react";
import "./style.scss";

const Glitch = ({ text, style, className }) => {
  return (
    <div class={"glitch"} className={className} data-text={text} style={style}>
      {text}
    </div>
  );
};

export { Glitch };
